import { forwardRef } from "react";
import { FormControl } from "../FormControl";
import { useFormControlProps } from "../hooks";
import type { BaseFormProps } from "../types";
import type { BaseRadioCardProps } from "./BaseRadioCard";
import { BaseRadioCard } from "./BaseRadioCard";

export type RadioCardProps = BaseRadioCardProps & BaseFormProps;

const RadioCardInner = (props: RadioCardProps, ref: React.ForwardedRef<HTMLDivElement>) => {
	const { formControlProps, errorAria, baseProps: radioCardProps } = useFormControlProps(props);

	return (
		<FormControl {...formControlProps}>
			<BaseRadioCard {...radioCardProps} {...errorAria} ref={ref} />
		</FormControl>
	);
};

RadioCardInner.displayName = "RadioCard";

export const RadioCard = forwardRef(RadioCardInner);
